import { ActiveAccountActionTypes } from "../../../action-types";

export const setActiveAccount = (activeAccount) => {
  localStorage.setItem("activeAccount", JSON.stringify(activeAccount));
  return {
    type: ActiveAccountActionTypes.SET_ACTIVE_ACCOUNT,
    payload: activeAccount,
  };
};